export var Mode;
(function (Mode) {
    Mode["Light"] = "light";
    Mode["Dark"] = "dark";
})(Mode || (Mode = {}));
export var Density;
(function (Density) {
    Density["Comfortable"] = "comfortable";
    Density["Compact"] = "compact";
})(Density || (Density = {}));
function hasValue(allValues, mode) {
    return Object.keys(allValues).some(function (key) { return allValues[key] === mode; });
}
function toggleClass(target, className, enabled) {
    // NB: classList.toggle does not support second argument in IE
    if (enabled) {
        target.classList.add(className);
    }
    else {
        target.classList.remove(className);
    }
}
export function applyMode(mode, target) {
    if (target === void 0) { target = document.body; }
    if (mode && !hasValue(Mode, mode)) {
        console.warn("Mode \"".concat(mode, "\" is not supported"));
        return;
    }
    toggleClass(target, 'awsui-dark-mode', mode === Mode.Dark);
}
export function applyDensity(density, target) {
    if (target === void 0) { target = document.body; }
    if (density && !hasValue(Density, density)) {
        console.warn("Density \"".concat(density, "\" is not supported"));
        return;
    }
    toggleClass(target, 'awsui-compact-mode', density === Density.Compact);
}
export function disableMotion(disabled, target) {
    if (target === void 0) { target = document.body; }
    toggleClass(target, 'awsui-motion-disabled', disabled);
}
